export default "__VITE_ASSET__BgZu7GPk__"